"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment Breadcrumbs on BreadcrumbLinks {\n    links {\n      relativeUrl\n      title\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breadcrumbs = void 0;
var _fetching = require("@ori/fetching");
const breadcrumbs = exports.breadcrumbs = (0, _fetching.gql)(_templateObject());
